<template>
  <div class="template">
    <StakeholdersZoomParams />
    <LoaderFullPage v-if="storeStakeholder.isAuthorLoading" />
    <div v-else>
      <StakeholdersZoomDatas />
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import StakeholdersZoomParams from "@follaw-fr/components/social-media/stakeholders/organisms/StakeholdersZoomParams.vue";
import StakeholdersZoomDatas from "@follaw-fr/components/social-media/stakeholders/organisms/StakeholdersZoomDatas.vue";
import LoaderFullPage from "@follaw-fr/components/reusable/molecules/LoaderFullPage.vue";
import { useStakeholdersStore } from "@follaw-fr/stores/social-media/stakeholders";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const route = useRoute();
const storeStakeholder = useStakeholdersStore();
const userSettingsStore = useUserSettingsStore();

const preventGetAuthorZoom =
  storeStakeholder.authorZoom &&
  storeStakeholder.authorZoom._id === route.params._id;

if (
  !preventGetAuthorZoom &&
  userSettingsStore.hasPermission(PermissionLevel.SOCIETAL)
) {
  storeStakeholder.getAuthorZoom(route.params._id);
}
</script>
